import { useSelector } from 'react-redux';

export const useAdsEnabled = () => {
  const { userInfo } = useSelector((state) => state.auth);

  return !userInfo?.adFree;
};

export default useAdsEnabled;
